module.exports = __webpack_public_path__ + "img/Group 605.ec4321b6.png";